import React, { useEffect, useState } from "react";
import "../cstm.style.css";

const API_BASE = "https://usethecred.com/api";

const Home = ({ b2bUniqueCustomers = 53 }) => {
  const [dsaUniqueCustomers, setDsaUniqueCustomers] = useState(0);
  const [dealXUniqueCustomers, setDealXUniqueCustomers] = useState(0);

  useEffect(() => {
    // DSA total
    fetch(`${API_BASE}/get_dsa_count.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data && typeof data.total === "number") {
          setDsaUniqueCustomers(data.total);
        }
      })
      .catch((err) => {
        console.error("Error fetching DSA summary:", err);
      });

    // DealX total (your loans table)
    fetch(`${API_BASE}/dealxCount.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data && typeof data.total === "number") {
          setDealXUniqueCustomers(data.total);
        }
      })
      .catch((err) => {
        console.error("Error fetching DealX summary:", err);
      });
  }, []);

  return (
    <div className="home-page">
      <h3 className="home-sub-title">UTC Products</h3>

      <div className="kpi-cards-row">
        <div className="kpi-card">
          <div className="kpi-card-title">DSA</div>
          <div className="kpi-card-metric">
            {dsaUniqueCustomers.toLocaleString()}
          </div>
          <div className="kpi-card-label">Total Leads</div>
        </div>

        <div className="kpi-card">
          <div className="kpi-card-title">DealX</div>
          <div className="kpi-card-metric">
            {dealXUniqueCustomers.toLocaleString()}
          </div>
          <div className="kpi-card-label">Total Loans</div>
        </div>

        <div className="kpi-card">
          <div className="kpi-card-title">B2B Leads</div>
          <div className="kpi-card-metric">
            {b2bUniqueCustomers.toLocaleString()}
          </div>
          <div className="kpi-card-label">Total Leads</div>
        </div>
      </div>
    </div>
  );
};

export default Home;
